import { render } from "./SimViewDeny.vue?vue&type=template&id=7edd590e&scoped=true&ts=true"
import script from "./SimViewDeny.vue?vue&type=script&lang=ts"
export * from "./SimViewDeny.vue?vue&type=script&lang=ts"

import "./SimViewDeny.vue?vue&type=style&index=0&id=7edd590e&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src613357358/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7edd590e"]])

export default __exports__